import React from 'react';
import { Alert, Snackbar, AlertColor, Paper, Theme } from '@mui/material';

interface ToastProps {
  open: boolean;
  message: string;
  severity: AlertColor;
  onClose: () => void;
  autoHideDuration?: number;
}

const Toast: React.FC<ToastProps> = ({
  open,
  message,
  severity,
  onClose,
  autoHideDuration = 6000,
}) => {
  const getBorderColor = (severity: AlertColor) => {
    switch (severity) {
      case 'error':
        return (theme: Theme) => theme.palette.error.main;
      case 'warning':
        return (theme: Theme) => theme.palette.warning.main;
      case 'info':
        return (theme: Theme) => theme.palette.info.main;
      case 'success':
      default:
        return (theme: Theme) => theme.palette.success.main;
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      // Ensure it appears above dialogs by setting high z-index
      sx={{
        zIndex: theme => theme.zIndex.snackbar + 1000,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          border: '1px solid',
          borderColor: getBorderColor(severity),
          borderRadius: 1,
        }}
      >
        <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Paper>
    </Snackbar>
  );
};

export default Toast;
